/** @format */

import ColiverIcon from '@/assets/icons/dovevivo_colivers_icon.svg';
import IconEye from '@/assets/icons/dovevivo_icon_eye_new.svg';
import { GTMVisitOtherRoomsv2 } from '@/ducks/googleTagManager/helpers/google-tag-manager';
import { Tenant, TRoom } from '@/ducks/room/declarations';
import { utilityCalculateRoomURL } from '@/ducks/room/helpers';
import { TLocale } from '@/utils/gatsby/types';
import { useIntl } from 'gatsby-plugin-intl';
import React, { FC, memo, useMemo } from 'react';
import {
  AvailableRoomTitle,
  Ellipse,
  RoomBoxContainer,
  RoomBoxRoomNumber,
  VisitLink,
  VisitLinkWrapper,
} from './RoomBox.style';

export const RoomBox: FC<RoomBoxProps> = memo(({ isThisRoom = false, room, roomPrice }) => {
  const { locale, formatMessage } = useIntl();
  if (room.type === 'coliver') return null;
  const { localizedData, roomNumber } = room;
  const handleGTMVisitOtherRoomsv2 = (id?: string) => {
    GTMVisitOtherRoomsv2(id ? id : 'show_all', room.bedCode, roomPrice);
  };
  const showVisitLink = useMemo(() => {
    if (isThisRoom) return false;
    return room.available;
  }, [isThisRoom, room]);
  const visitRoomLink = useMemo(() => {
    if (!showVisitLink) return false;

    if (!localizedData) return false;
    if (localizedData.length === 0) return false;
    if (localizedData.every(lang => !isValidPDPUrl(lang.url))) return false;
    return utilityCalculateRoomURL({ room: room as any as TRoom, locale: locale as TLocale });
  }, [showVisitLink, localizedData, locale, room]);
  return (
    <RoomBoxContainer>
      <img role="presentation" src={ColiverIcon} />
      <div>
        <RoomBoxRoomNumber>
          {isThisRoom && <Ellipse />}
          {formatMessage({ id: 'pdp.room_number' }, { room_number: roomNumber })}
        </RoomBoxRoomNumber>
        <AvailableRoomTitle>
          {!!visitRoomLink && (
            <VisitLinkWrapper>
              <VisitLink target="_blank" onClick={() => handleGTMVisitOtherRoomsv2(roomNumber)} to={visitRoomLink}>
                <img src={IconEye} role="presentation" />
                {formatMessage({ id: 'pdp.view' })}
              </VisitLink>
            </VisitLinkWrapper>
          )}
          {!visitRoomLink && !isThisRoom && formatMessage({ id: 'unavailable' })}
          {isThisRoom && formatMessage({ id: 'pdp.this_room' })}
        </AvailableRoomTitle>
      </div>
    </RoomBoxContainer>
  );
});
const isValidPDPUrl = (url: string) => url.split('/').length > 4;
type RoomBoxProps = {
  isThisRoom: boolean;
  roomPrice: number;
  room: Tenant;
};
